import AppOld from './App';
import AppNew from '../AppNew';
import { useExperiments } from '../../contexts/ExperimentsContext';
import React from 'react';

export default () => {
  const experiments = useExperiments();
  const App = experiments.is('specs.funnel.StudioTemplatesPageNewUI', 'true')
    ? AppNew
    : AppOld;

  return <App />;
};
